module.exports = __webpack_public_path__ + "static/media/clover.33b71b72.svg";